
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
'use strict';
const $09e991522ca7e64e$var$gameCell = document.querySelectorAll('.field-cell');
const $09e991522ca7e64e$var$button = document.querySelector('button');
const $09e991522ca7e64e$var$scoreInfo = document.querySelector('.game-score');
const $09e991522ca7e64e$var$messageStart = document.querySelector('.message-start');
const $09e991522ca7e64e$var$messageWin = document.querySelector('.message-win');
const $09e991522ca7e64e$var$messageLose = document.querySelector('.message-lose');
const $09e991522ca7e64e$var$message = document.querySelector('.message-container');
const $09e991522ca7e64e$var$number = document.querySelector('.game-score-number');
let $09e991522ca7e64e$var$score = 0;
var $9c4c822ef6cf8fbe$exports = {};
'use strict';
var $59929059b1c6118c$exports = {};

$parcel$export($59929059b1c6118c$exports, "Cell", function () { return $59929059b1c6118c$export$f6f0c3fe4ec306ea; });
class $59929059b1c6118c$export$f6f0c3fe4ec306ea {
    constructor(x, y){
        this.x = x;
        this.y = y;
        this.valueNum = undefined;
    }
}
$59929059b1c6118c$exports = $59929059b1c6118c$export$f6f0c3fe4ec306ea;


const $9c4c822ef6cf8fbe$var$ROWS_SIZE = 4;
const $9c4c822ef6cf8fbe$var$COLUMNS_SIZE = 4;
function $9c4c822ef6cf8fbe$var$getRandomNumber() {
    return Math.random() <= 0.9 ? 2 : 4;
}
class $9c4c822ef6cf8fbe$var$Game {
    constructor(){
        this.board = [];
        for(let row = 0; row < $9c4c822ef6cf8fbe$var$ROWS_SIZE; row++)for(let column = 0; column < $9c4c822ef6cf8fbe$var$COLUMNS_SIZE; column++)this.board.push(new $59929059b1c6118c$exports(row, column));
    }
    getRandomCell() {
        const emptyCells = this.board.filter((cell)=>cell.valueNum === undefined);
        const randomIndex = Math.floor(Math.random() * emptyCells.length);
        return emptyCells[randomIndex] || undefined;
    }
    getValues() {
        const valueCells = this.board.filter((cellItem)=>cellItem.valueNum !== undefined);
        return valueCells;
    }
    addNumber() {
        const cell = this.getRandomCell();
        if (!cell) return;
        cell.valueNum = $9c4c822ef6cf8fbe$var$getRandomNumber();
    }
    updateBoard() {
        this.board.forEach((cell)=>{
            const num = cell.valueNum !== undefined ? cell.valueNum : undefined;
            const x = cell.x;
            const y = cell.y;
            const boardElement = document.getElementById(`${x}-${y}`);
            if (num !== undefined) {
                boardElement.classList.value = '';
                boardElement.classList.add('field-cell');
                boardElement.textContent = num;
                boardElement.classList.add(`field-cell--${num}`);
                boardElement.classList.toggle('animation-appear');
            } else {
                boardElement.textContent = '';
                boardElement.classList.value = '';
                boardElement.classList.add('field-cell');
            }
        });
    }
    getBoardValues() {
        return this.board.map((cell)=>cell.valueNum);
    }
    isGameOver() {
        if (this.getRandomCell()) return false;
        for (const cell of this.board){
            const right = this.board.find((c)=>c.x === cell.x && c.y === cell.y + 1);
            const down = this.board.find((c)=>c.x === cell.x + 1 && c.y === cell.y);
            if (right && right.valueNum === cell.valueNum || down && down.valueNum === cell.valueNum) return false;
        }
        return true;
    }
}
$9c4c822ef6cf8fbe$exports = $9c4c822ef6cf8fbe$var$Game;


const $09e991522ca7e64e$var$game = new $9c4c822ef6cf8fbe$exports();
// Animation after page has loaded
function $09e991522ca7e64e$var$loadPageNotification() {
    $09e991522ca7e64e$var$button.removeAttribute('disabled');
    $09e991522ca7e64e$var$messageStart.style.bottom = '40%';
    const startNotif = new Promise((resolve)=>{
        window.addEventListener('load', ()=>{
            setTimeout(()=>{
                resolve();
            }, 1000);
        });
    });
    startNotif.then(()=>{
        $09e991522ca7e64e$var$messageStart.style.opacity = '1';
        $09e991522ca7e64e$var$messageStart.style.transform = 'scale(1.3)';
        setTimeout(()=>{
            const setPositionStartNotif = new Promise((resolve)=>{
                resolve();
            });
            setPositionStartNotif.then(()=>{
                $09e991522ca7e64e$var$messageStart.style.bottom = '0%';
                $09e991522ca7e64e$var$messageStart.style.transform = 'scale(1)';
                return new Promise((resolve)=>{
                    setTimeout(()=>{
                        resolve();
                    }, 1000);
                });
            }).then(()=>{
                $09e991522ca7e64e$var$button.removeAttribute('disabled');
                $09e991522ca7e64e$var$button.style.animation = 'button-bloom 1s ease';
            });
        }, 1000);
    });
}
$09e991522ca7e64e$var$loadPageNotification();
// Function for identify each cell (Creation id such us '0-1' for each cell)
function $09e991522ca7e64e$var$createId() {
    let x = 0;
    let y = 0;
    $09e991522ca7e64e$var$gameCell.forEach((item)=>{
        item.id = `${x}-${y}`;
        if (y < 3) y++;
        else {
            x++;
            y = 0;
        }
    });
}
$09e991522ca7e64e$var$createId();
// Event for button which can represent "Start" or "Restart"
$09e991522ca7e64e$var$button.addEventListener('click', (e)=>{
    $09e991522ca7e64e$var$message.style.opacity = '0'; // Hide all messages under gameboard
    $09e991522ca7e64e$var$messageStart.style.opacity = '0';
    // Return location of all messages to initial state
    $09e991522ca7e64e$var$messageLose.style.bottom = '0%';
    $09e991522ca7e64e$var$messageWin.style.bottom = '0%';
    $09e991522ca7e64e$var$messageStart.style.bottom = '0%';
    // Hide all messages under gameboard
    $09e991522ca7e64e$var$messageLose.classList.add('hidden');
    $09e991522ca7e64e$var$messageWin.classList.add('hidden');
    // Screenplay for activation game and behavior for "Start" botton
    if ($09e991522ca7e64e$var$button.classList.contains('start')) {
        $09e991522ca7e64e$var$button.textContent = 'Restart';
        $09e991522ca7e64e$var$button.classList.remove('start');
        $09e991522ca7e64e$var$button.classList.add('restart');
        $09e991522ca7e64e$var$game.addNumber();
        $09e991522ca7e64e$var$game.addNumber();
        $09e991522ca7e64e$var$game.updateBoard();
    // Screenplay for behavior "Start" botton
    } else if ($09e991522ca7e64e$var$button.classList.contains('restart')) {
        $09e991522ca7e64e$var$game.getValues().forEach((cellItem)=>{
            cellItem.valueNum = undefined;
        });
        $09e991522ca7e64e$var$game.updateBoard();
        $09e991522ca7e64e$var$button.textContent = 'Start';
        $09e991522ca7e64e$var$button.style.width = '100px';
        $09e991522ca7e64e$var$button.classList.remove('restart');
        $09e991522ca7e64e$var$button.classList.add('start');
        $09e991522ca7e64e$var$score = 0;
        $09e991522ca7e64e$var$scoreInfo.textContent = '0';
    }
});
// Creation rows from Game class
function $09e991522ca7e64e$var$createRows() {
    return $09e991522ca7e64e$var$game.board.reduce((boardRows, cell)=>{
        if (!boardRows[cell.x]) boardRows[cell.x] = [];
        boardRows[cell.x].push(cell);
        return boardRows;
    }, []);
}
// Creation columns from Game class
function $09e991522ca7e64e$var$createColumns() {
    return $09e991522ca7e64e$var$game.board.reduce((boardColumns, cell)=>{
        if (!boardColumns[cell.y]) boardColumns[cell.y] = [];
        boardColumns[cell.y].push(cell);
        return boardColumns;
    }, []);
}
function $09e991522ca7e64e$var$handleKeyUp(e) {
    const rows = $09e991522ca7e64e$var$createRows();
    const columns = $09e991522ca7e64e$var$createColumns();
    const prevBoard = $09e991522ca7e64e$var$game.getBoardValues();
    const moveTypes = {
        ArrowLeft: ()=>$09e991522ca7e64e$var$moveLeft(rows),
        ArrowRight: ()=>$09e991522ca7e64e$var$moveRight(rows),
        ArrowDown: ()=>$09e991522ca7e64e$var$moveDown(columns),
        ArrowUp: ()=>$09e991522ca7e64e$var$moveUp(columns)
    };
    const move = moveTypes[e.code];
    if (!move) return;
    const mergedNum = move();
    const currentBoard = $09e991522ca7e64e$var$game.getBoardValues();
    const boardChanged = prevBoard.some((val, i)=>val !== currentBoard[i]);
    if (!boardChanged) return;
    if (mergedNum > 0) {
        $09e991522ca7e64e$var$score += mergedNum;
        $09e991522ca7e64e$var$setScore(); // Update Score in gameboard
    }
    $09e991522ca7e64e$var$game.addNumber();
    $09e991522ca7e64e$var$checkGameOver();
    $09e991522ca7e64e$var$game.updateBoard(); // Update HTML
}
document.addEventListener('keyup', $09e991522ca7e64e$var$handleKeyUp);
// Implementatiom moveup
function $09e991522ca7e64e$var$moveUp(columns) {
    let newScore = 0;
    columns.forEach((column)=>{
        const cellVal = column.map((cellItem)=>cellItem.valueNum).filter((cellItem)=>cellItem !== undefined);
        // iteration and check, are there duble numbers
        for(let i = 0; i < cellVal.length - 1; i++)if (cellVal[i] === cellVal[i + 1]) {
            cellVal[i] *= 2; // if yes, duble number
            newScore += cellVal[i]; // increase score variable
            $09e991522ca7e64e$var$number.textContent = `+${cellVal[i]}`; // embed increasing number to 'number' variable, which represent animation over score
            cellVal.splice(i + 1, 1);
        }
        // add objects for achiving initial column length
        while(cellVal.length < column.length)cellVal.push(undefined);
        // replace initials column values to new values
        for(let i = 0; i < column.length; i++)column[i].valueNum = cellVal[i];
    });
    return newScore;
}
function $09e991522ca7e64e$var$moveDown(columns) {
    let newScore = 0;
    columns.forEach((column)=>{
        const cellVal = column.map((cellItem)=>cellItem.valueNum).filter((cellItem)=>cellItem !== undefined);
        // iteration and check, are there duble numbers
        for(let i = cellVal.length - 1; i > 0; i--)if (cellVal[i] === cellVal[i - 1]) {
            cellVal[i] *= 2; // if yes, duble number
            newScore += cellVal[i]; // increase score
            $09e991522ca7e64e$var$number.textContent = `+${cellVal[i]}`; // embed increasing number to 'number' variable, which represent animation over score
            cellVal.splice(i - 1, 1);
        }
        while(cellVal.length < column.length)cellVal.unshift(undefined);
        for(let i = 0; i < column.length; i++)column[i].valueNum = cellVal[i];
    });
    return newScore;
}
function $09e991522ca7e64e$var$moveRight(rows) {
    let newScore = 0;
    rows.forEach((row)=>{
        const cellVal = row.map((cellItem)=>cellItem.valueNum).filter((cellItem)=>cellItem !== undefined);
        for(let i = cellVal.length - 1; i > 0; i--)if (cellVal[i] === cellVal[i - 1]) {
            cellVal[i] *= 2;
            newScore += cellVal[i];
            $09e991522ca7e64e$var$number.textContent = `+${cellVal[i]}`;
            cellVal.splice(i - 1, 1);
        }
        while(cellVal.length < row.length)cellVal.unshift(undefined);
        for(let i = 0; i < row.length; i++)row[i].valueNum = cellVal[i];
    });
    return newScore;
}
function $09e991522ca7e64e$var$moveLeft(rows) {
    let newScore = 0;
    rows.forEach((row)=>{
        const cellVal = row.map((cellItem)=>cellItem.valueNum).filter((cellItem)=>cellItem !== undefined);
        for(let i = 0; i < cellVal.length - 1; i++)if (cellVal[i] === cellVal[i + 1]) {
            cellVal[i] *= 2;
            newScore += cellVal[i];
            $09e991522ca7e64e$var$number.textContent = `+${cellVal[i]}`;
            cellVal.splice(i + 1, 1);
        }
        while(cellVal.length < row.length)cellVal.push(undefined);
        for(let i = 0; i < row.length; i++)row[i].valueNum = cellVal[i];
    });
    return newScore;
}
// Updation score and implementation victorious screenplay
function $09e991522ca7e64e$var$setScore() {
    $09e991522ca7e64e$var$scoreInfo.textContent = $09e991522ca7e64e$var$score; // Update HTML
    // set animation class for score
    $09e991522ca7e64e$var$number.classList.add('animation-number-slide');
    setTimeout(()=>{
        $09e991522ca7e64e$var$number.classList.remove('animation-number-slide');
    }, 800);
    // implementation victorious screenplay
    const haveVictoriousNum = $09e991522ca7e64e$var$game.board.some((cell)=>cell.valueNum >= 2048);
    if (haveVictoriousNum === true) {
        $09e991522ca7e64e$var$message.style.opacity = '1';
        $09e991522ca7e64e$var$messageWin.classList.remove('hidden');
        setTimeout(()=>{
            $09e991522ca7e64e$var$messageWin.style.bottom = '40%';
            $09e991522ca7e64e$var$messageWin.style.transform = 'scale(1.3)';
        }, 1000);
        document.removeEventListener('keyup', $09e991522ca7e64e$var$handleKeyUp);
    }
}
// implementation losing screenplay
function $09e991522ca7e64e$var$checkGameOver() {
    if ($09e991522ca7e64e$var$game.isGameOver()) {
        $09e991522ca7e64e$var$message.style.opacity = '1';
        $09e991522ca7e64e$var$messageLose.classList.remove('hidden');
        $09e991522ca7e64e$var$messageLose.textContent = `You lose with ${$09e991522ca7e64e$var$score} score`;
        setTimeout(()=>{
            $09e991522ca7e64e$var$messageLose.style.bottom = '40%';
            $09e991522ca7e64e$var$messageLose.style.transform = 'scale(1.3)';
        }, 1000);
        document.removeEventListener('keyup', $09e991522ca7e64e$var$handleKeyUp);
    }
}


//# sourceMappingURL=portfolio-2048-game.bd445c16.js.map
